import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { deviceDeletedResponseSchema } from '../types';

export const receiveDeviceDeleted = createReceive(
	'device-deleted',
	zodContract(deviceDeletedResponseSchema),
);
